

























import { Component, Vue, Prop, Watch } from 'nuxt-property-decorator'
import cloneDeep from 'lodash/cloneDeep'
import { resizeImg } from '~/share/utils'

@Component
export default class HorizontalScroll extends Vue {
  @Prop() imgList!: any

  cloneImgLit: any = []
  isImgLoaded: boolean = false

  @Watch('imgList', { immediate: true, deep: true })
  onImgListChange(val: any) {
    if (val?.length) {
      this.cloneImgLit = this.formatImgList(val)
    }
  }

  formatImgList(list: any) {
    if (process.server) { return }
    const source = cloneDeep(list)
    const isOnePic = source.length === 1
    const screenWidth = document.documentElement.clientWidth - 40
    const width = screenWidth - (isOnePic ? 0 : 32)

    return source.map((item: any) => {
      item.image_url = resizeImg(item.image_url, 2 * width, 272)
      return item
    })
  }

  genHref(path: string) {
    if (process.client) {
      const origin = window.location.origin
      return origin + path
    }

    return path
  }

  getSpm(deeplink: string, index: number) {
    const ext = { LinkURL: this.genHref(deeplink) }

    return `CampaignBanner_LIST?idx=${index}&len=${this.imgList.length}&ext=${encodeURIComponent((JSON.stringify(ext)))}`
  }

  handleImgLoaded() {
    if (!this.isImgLoaded) {
      this.isImgLoaded = true
    }
  }
}
